import classNames from 'classnames';

import styles from '../../styles/animations/mes-quebec/custom-button.module.css';

interface CustomButtonProps {
    className?: string | null;
    cta?: string | null;
    link?: string | null;
}

function CustomButton({ className = null, cta = null, link = null, ...props }: CustomButtonProps) {
    return (
        <div className={classNames(styles.container, className)}>
            <a className={styles.button} href={link} target="_blank" rel="noreferrer">
                {cta}
            </a>
        </div>
    );
}

export default CustomButton;
